<template>
	<div class="receipt_edit">
		<div class="changead">
			<div class="inputdata">
				<div class="changeadinput">
					<span style="color: black;margin-right: 20px;">修改发票状态</span>
					 <el-select v-model="status" placeholder="请选择" style="margin-bottom: 20px;">
					    <el-option
					      v-for="item in types"
					      :key="item.id"
					      :label="item.value"
					      :value="item.id">
					    </el-option>
					  </el-select>
					<el-button type="primary" @click="sumbitEdit()">提交</el-button>
					<el-button type="primary" @click="closeEdit()">取消</el-button>
				</div>
			</div>
			
		</div>
		
		
		
	</div>
</template>

<script>
	export default{
		name:'receipt-edit',
		props:['receiptId'],
		data(){
			return{
				status:'',
				types:[
					{
						id:'0',
						value:'未开'
					},
					{
						id:'1',
						value:'已开'
					},
					{
						id:'2',
						value:'已取'
					},
				]
			}
		},
		methods:{
			closeEdit(){
				this.$emit('closeedit')
			},
			sumbitEdit(){
				let status = this.status
				if(status == ''){
					return this.$message({
						type:'warning',
						message:'请选择发票状态',
						duration:1000
					})
				}
				this.closeEdit()
				this.$jssdk.receipt.edit({receipt_id:this.receiptId,status:status},(data) =>{
					console.log(data)
					this.$message({
						type:'success',
						message:'修改状态成功',
						duration:1000
					})
				},(err) =>{
					this.$message({
						type:'warning',
						message:err.msg,
						duration:1000
					})
				})
			},
		},
	}
</script>

<style scoped="scoped">
	.receipt_edit{
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 980px;
		background-color: rgba(0,0,0,.5);
		z-index: 10;
		color: white;
	}
	.changead{
		background-color: white;
		width:450px;
		position: absolute;
		left: 740px;
		top: 340px;
		z-index: 3;
		overflow: hidden;
		padding: 15px;
		border-radius: 15px;
		border:1px solid #ccc;
		box-shadow: 2px 2px 2px #000;
	}
	.changeadinput{
		width: 370px;
		color: red;
		margin: 0 auto;
		text-align: center;
		padding: 20px 0;
	}
	@media only screen and (max-width:1400px ) {
		.changead{
			background-color: white;
			width:450px;
			position: absolute;
			left: 440px;
			top: 140px;
			color: white;
			z-index: 3;
			overflow: hidden;
			padding: 15px;
			border-radius: 15px;
			border:1px solid #ccc;
			box-shadow: 2px 2px 2px #000;
		}
	}
</style>


// WEBPACK FOOTER //
// receiptEdit.vue?6038c12a